export function HeroIcon({
  w = "40",
  h = "40",
  className,
}: {
  h?: string | number
  w?: string | number
  className?: string
}) {
  return (
    <svg width={w} height={h} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M33.3811 4H6.38053C6.01439 4 5.66325 4.14545 5.40435 4.40435C5.14545 4.66325 5 5.01439 5 5.38053V22.2882C4.9999 22.5252 5.04995 22.7596 5.14686 22.9759C5.24377 23.1922 5.38535 23.3856 5.5623 23.5433L19.2784 35.7704C19.4442 35.9183 19.6586 36 19.8808 36C20.103 36 20.3174 35.9183 20.4832 35.7704L34.1993 23.542C34.3763 23.3843 34.5178 23.1909 34.6147 22.9746C34.7117 22.7583 34.7617 22.5239 34.7616 22.2869V5.38053C34.7616 5.19924 34.7259 5.01972 34.6565 4.85223C34.5871 4.68473 34.4854 4.53254 34.3573 4.40435C34.2291 4.27615 34.0769 4.17447 33.9094 4.10509C33.7419 4.03571 33.5624 4 33.3811 4ZM31.7885 21.7091L19.8808 32.3255L7.97306 21.7091V6.97306H31.7885V21.7091Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M15.7591 9.38379H17.5688V13.2643H20.525L20.5366 15.3997H22.1925V9.38379H24.0022V15.3997H29.5321V9.38379H10.2305V13.2643H15.7591V9.38379Z"
        fill="white"
      />
      <path
        d="M24.1974 25.1605C22.6966 21.121 17.57 20.3778 17.0879 20.3196C14.6539 20.0003 14.7185 18.5099 14.7185 18.5099H17.1409C17.5145 18.5099 18.7334 18.3807 18.7334 16.9161V15.0741H10.2305V20.4062L19.8813 29.0087L24.1974 25.1605Z"
        fill="white"
      />
      <path
        d="M19.8086 19.1173C20.2484 19.2663 20.6799 19.4389 21.1012 19.6343C23.225 20.6193 24.7581 22.0735 25.6177 23.8897L29.5266 20.3996V17.2094H20.526C20.4946 17.9052 20.2435 18.5732 19.8086 19.1173Z"
        fill="white"
      />
    </svg>
  )
}
